import React from 'react'
import { useAuthStore } from '../stores/auth'
import { ProtectedRoute } from './ProtectedRoute'

interface PublicOrProtectedRouteProps {
  publicComponent: React.ComponentType
  protectedComponent: React.ComponentType
  requireAuth?: boolean
  requireAdmin?: boolean
}

export function PublicOrProtectedRoute({
  publicComponent: PublicComponent,
  protectedComponent: ProtectedComponent,
  requireAuth = false,
  requireAdmin = false
}: PublicOrProtectedRouteProps) {
  const { isAuthenticated } = useAuthStore()

  // 如果需要认证且用户已登录，显示受保护的内容
  if (requireAuth && isAuthenticated) {
    return (
      <ProtectedRoute requireAdmin={requireAdmin}>
        <ProtectedComponent />
      </ProtectedRoute>
    )
  }

  // 如果不需要认证或用户未登录，显示公开的内容
  return <PublicComponent />
}
